import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { postDetails } from "../../../services/postService";
import MenuTabsWithLink from "../../../components/common/MenuTabs";
import Image from "../../../components/elements/Image";

import PostContent from "./PostContent";
import Comment from "../comment/Comment";

export default function PostDetails() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    async function fetchData() {
      const res = await postDetails(id);
      setData(res?.data);
    }
    fetchData();
  }, [id]);

  if (!data) return <div className="p-4">Loading...</div>;

  const { title, content, favourite, shares, media, publishedAt, userData } =
    data;
  const tabs = [
    {
      key: "content",
      label: "Content",
      conent: <PostContent content={content} />,
    },
    {
      key: "comment",
      label: "Comment",
      conent: <Comment referrerId={id} />,
    },
  ];
  return (
    <>
      <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
        Post Details
      </div>
      <div className="p-6">
        {/* Header Info Section */}
        <div className="bg-white rounded-xl shadow-md p-6 mb-6 flex flex-col md:flex-row items-center gap-6">
          {/* Post Image */}
          <div className="w-32 h-32">
            <Image
              src={media?.[0]?.url}
              width={128}
              height={128}
              alt="Post Media"
              classes="w-full h-full object-cover rounded-full border"
            />
          </div>

          {/* Info Grid */}
          <div className="flex-1 grid md:grid-cols-2 gap-6">
            {/* Post Info */}
            <div>
              <h2 className="text-xl font-semibold">Post Tittle: {title}</h2>
              <p className="text-sm text-gray-600 mt-1">
                Published: {new Date(publishedAt).toLocaleDateString()}
              </p>
              <div className="mt-2 text-sm">
                <span className="mr-4">❤️ Favourites: {favourite.length}</span>
                <span>🔗 Shares: {shares.length}</span>
              </div>
            </div>

            {/* User Info */}
            <div className="flex items-start gap-4">
              <div className="w-20 h-20">
                <Image
                  src={userData?.image?.url}
                  width={64}
                  height={64}
                  alt="User"
                  classes="w-16 h-16 rounded-full object-cover border"
                />
              </div>
              <div>
                <p className="font-medium">
                  {userData?.firstName} {userData?.lastName}
                </p>
                <p className="text-sm text-gray-500">{userData?.email}</p>
                <p className="text-sm text-gray-500">
                  Phone: {userData?.phone}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <MenuTabsWithLink
          classNames="mb-6"
          menu={tabs}
          isLinkEnable={false}
          setActiveIndex={setActiveTab}
        />

        {/* Content */}
        <div className="bg-white rounded-xl shadow-md p-6">
          {tabs[activeTab]?.conent}
        </div>
      </div>
    </>
  );
}
